import React from 'react';
import { any, bool, func, oneOf } from 'prop-types';
import styled from 'styled-components';
import { borderRadius, color } from '@core-ds/primitives';
import { SmallCross } from '../../constants/icons';

const labelColors = {
   light: {
      black: {
         backgroundColor: color.gray1,
         fillColor: color.gray6,
      },
      blue: {
         backgroundColor: color.blueLight4,
         fillColor: color.blueDark1,
      },
      green: {
         backgroundColor: color.greenLight4,
         fillColor: color.greenDark1,
      },
      red: {
         backgroundColor: color.redLight4,
         fillColor: color.redDark1,
      },
      yellow: {
         backgroundColor: color.yellowLight4,
         fillColor: color.yellowDark2,
      },
   },
   dark: {
      black: {
         backgroundColor: color.gray7,
         fillColor: color.white,
      },
      blue: {
         backgroundColor: color.blueLight1,
         fillColor: color.white,
      },
      green: {
         backgroundColor: color.greenLight1,
         fillColor: color.white,
      },
      red: {
         backgroundColor: color.redLight1,
         fillColor: color.white,
      },
      yellow: {
         backgroundColor: color.yellowLight1,
         fillColor: color.black,
      },
   },
};

const iconColors = {
   light: color.black,
   dark: color.white,
};

const LabelContainer = styled.div`
   display: inline-block;
`;

const LabelText = styled.div`
   display: flex;
   align-items: center;
   font-size: ${props => (props.size === 'large' ? '0.8125rem' : '0.75rem')};
   padding: 1px ${props => (props.size === 'large' ? '0.375rem' : '0.25rem')};
   font-weight: bold;
   color: ${props => props.fillColor};
   background-color: ${props => props.backgroundColor};
   border-radius: ${borderRadius.md};
   text-shadow: ${props => props.theme === 'dark' && '0px 1px 0px rgba(0, 0, 0, 0.15)'};
`;

const CloseIcon = styled(SmallCross)`
   margin-left: 6px;
   opacity: ${props => (props.theme === 'light' ? 0.15 : 0.5)};
   cursor: pointer;
`;

const Label = ({
   color = 'black',
   closeable = false,
   theme = 'light',
   onClose = () => {},
   children,
   ...props
}) => (
   <LabelContainer {...props}>
      <LabelText theme={theme} {...labelColors[theme][color]}>
         {children}
         {closeable && (
            <CloseIcon fillColor={iconColors[theme]} size={8} theme={theme} onClick={onClose} />
         )}
      </LabelText>
   </LabelContainer>
);

Label.propTypes = {
   color: oneOf(['black', 'blue', 'green', 'red', 'yellow']),
   closeable: bool,
   size: oneOf(['small', 'large']),
   theme: oneOf(['light', 'dark']),
   onClose: func,
   children: any.isRequired,
};

export default Label;
